import React from 'react'
import { Modal } from '@components'
import {
	iFrameHelper,
	dateHelper,
	history,
	isWithinRebookingWindow,
	legsFromOffer
} from '@helpers'
import styled from 'styled-components'
import TripOption from './trip-option-container.component'
import NoTripsFound from './no-trips-found.component'
import BusSeatSelection from './bus-seat-selection/bus-seat-selection.component'
import TicketSaleService from '../../../services/ticket-sale.service'
import { CartService } from '../../../services/cart.service'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import BusSeatSelectionSelectors from '../../../selectors/bus-seat-selection.selectors'
import { connect } from 'react-redux'
import { GRAY, PRIMARY_LIGHT, WHITE } from '../../../styles/colors.style'
import { withRouter } from 'react-router-dom'
import { breakpoints, routes } from '@constants'
import { Creators as SiteCreators } from '../../../ducks/site/site'
import { toastActions, busSeatSelectionActions } from '@actions'
import {
	Creators as TicketSaleCreators,
	ticketSaleActions
} from '../../../ducks/ticket-sale/ticket-sale'
import { conexaoActions } from '../../../ducks/conexao/conexaoReducer'
import Browser from '../../../services/Browser'
import ConexaoSelectors from '../../../ducks/conexao/conexao.selectors'
import ConfirmModal from './confirm-modal/confirm-modal.component'
import ModalConfirmation from '../../../components/modal/modal-confirmation.component'
import moment from 'moment'
import CalendarCarousel from '../../calendar-carousel'

class OriginSelectStepComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			isModalOpen: false,
			isNoReturnModalOpen: false,
			isConfirmModalOpen: false,
			windowPosition: 0,
			options: {}
		}

		this.openModal = openModal.bind(this)
		this.closeModal = closeModal.bind(this)
		this.onContinue = onContinue.bind(this)
		this.redirectToPlans = redirectToPlans.bind(this)
		this.onOptionSelected = onOptionSelected.bind(this)
		this.deselectCurrentSeats = deselectCurrentSeats.bind(this)
		this.positionInitialMobilePage = positionInitialMobilePage.bind(this)
		this.mobileScroll = mobileScroll.bind(this)
		this.resetSeatsBus = resetSeatsBus.bind(this)
		this.changeConfirmModalStatus = changeConfirmModalStatus.bind(this)
		this.tripOptionOnSelect = tripOptionOnSelect.bind(this)
		this.setOptions = setOptions.bind(this)
		this.tripDate = React.createRef()
		this.confirmNonReturnTrip = this.confirmNonReturnTrip.bind(this)
		this.checkoutToNextStep = checkoutToNextStep.bind(this)
	}

	componentDidUpdate(nextState, prevState) {
		if (nextState.windowPosition !== prevState.windowPosition) {
			if (window.innerWidth <= 760) {
				setTimeout(() => {
					if (
						window.scrollY === 0 ||
						window.scrollY <= this.tripDate.current.offsetTop
					) {
						this.mobileScroll()
					}
				}, 0)
			}
		}
	}

	componentDidMount() {
		if (iFrameHelper.getTripParams().isValidParameters) {
			this.props.showLoading()
		}
		this.positionInitialMobilePage()
	}

	confirmNonReturnTrip(isConfirmed) {
		this.setState({
			isNoReturnModalOpen: false
		})

		if (isConfirmed) {
			this.checkoutToNextStep()
		}
	}

	render() {
		const {
			user,
			originTitle,
			setOriginGoing,
			tripsGoing,
			destinationTitle,
			setDestinationGoing,
			busSeatsGoing,
			tripDateGoing,
			tripDateReturn,
			totalSeatsGoing,
			selectBusSeatGoing,
			deselectBusSeatGoing,
			calculatedValues
		} = this.props

		const isPublicBody = user && user.hasChildren

		let msg = 'O melhor preço de passagens está aqui!'

		if (this.props.rebookingData.isRebooking) {
			msg = 'Selecione uma data para remarcar a passagem.'
		}

		let dateGoing

		if (tripDateGoing instanceof Date) {
			dateGoing = tripDateGoing
		} else if (tripDateGoing) {
			dateGoing = new Date(tripDateGoing.replace(/-/g, '/'))
		} else {
			dateGoing = new Date()
		}

		return (
			<StyledContainer>
				{tripsGoing.length && tripsGoing.length > 0 ? (
					<React.Fragment>
						<CalendarCarousel
							selectedDate={dateGoing}
							limitDate={this.props.tripDateReturn}
							isGoing={true}
							searchTrips={this.props.performSearchTrips}
							toastWarning={this.props.toastWarning}
							origin={originTitle}
							destination={destinationTitle}
						/>
						<StyledHeader>
							<div className="trip-date" ref={this.tripDate}>
								<span className="bold">
									{dateHelper.getDayMonth(dateGoing)}
								</span>
								<br />
								<span className="day-of-week">
									{dateHelper.getDayOfWeek(dateGoing)}
								</span>
							</div>
							<div className="trip-origin-destination">
								<h2>
									Passagem de ônibus de {originTitle.label} para{' '}
									{destinationTitle.label}
								</h2>
							</div>
						</StyledHeader>
						{tripsGoing.map((tripGoing, index, arr) => {
							const origin = tripGoing.origin ? `${tripGoing.origin.cityName} (${tripGoing.origin.stateCode})` : ''
							const destination = tripGoing.destination
								? `${tripGoing.destination.cityName} (${tripGoing.destination.stateCode})`
								: ''
							const originTerminalName = tripGoing.origin
								? tripGoing.origin.terminalName
								: ''
							const destinationTerminalName = tripGoing.destination
								? tripGoing.destination.terminalName
								: ''
							const isLow = tripGoing.availability
								? tripGoing.availability.isLow
								: false

							const promotion = !isPublicBody && !!tripGoing.discountPercent

							return (
								<TripOption
									key={index}
									price={{ value: tripGoing.fromPrice }}
									paymentOptions={tripGoing.paymentOptions}
									origin={origin}
									originTerminalName={originTerminalName}
									arrival={tripGoing.arrival}
									busClass={tripGoing.serviceClassLabel}
									promotion={promotion}
									departure={tripGoing.departure}
									freeSeats={tripGoing.availability ? tripGoing.availability.count : 0}
									isLow={isLow}
									carrier={tripGoing.carrier}
									tripDate={tripDateGoing}
									destination={destination}
									destinationTerminalName={destinationTerminalName}
									legs={tripGoing.legs}
									raceDate={tripGoing.raceDate}
									showFreeSeats={true}
									promotionPercent={tripGoing.discountPercent || 0}
									onSelect={async (price, doUpgrade) => {

										if (!calculatedValues.ticketsGoing.length) {
											await CartService.createCart(tripDateReturn)
										}

										setOriginGoing(tripGoing)
										setDestinationGoing(tripGoing)
										this.setOptions({
											...tripGoing,
											price,
											doUpgrade,
											index,
											arr,
											tripDateGoing
										})
									}}
								/>
							)
						})}
						<ModalConfirmation
							isOpen={this.state.isNoReturnModalOpen}
							title={'Não foram encontradas viagens de retorno!'}
							onResult={this.confirmNonReturnTrip}>
							<span>
								Não foram encontradas viagens de retorno para a data de viagem
								selecionada no campo de data de volta, porém você pode
								finalizar a compra da viagem de ida.
							</span>
							<br></br>
							<br></br>
							<span>
								Você deseja prosseguir com a finalização da sua compra de ida?
							</span>
						</ModalConfirmation>
						<Modal
							mobileFullWidth
							onClose={this.resetSeatsBus}
							isOpen={this.state.isModalOpen}>
							<BusSeatSelection
								busSeats={busSeatsGoing}
								onCancel={this.resetSeatsBus}
								onContinue={this.onContinue}
								totalSeats={totalSeatsGoing}
								onSelect={selectBusSeatGoing}
								onDeselect={deselectBusSeatGoing}
								isInsuranceRequired={
									!!this.state.options.forceInsurancePublicBody
								}
							/>
						</Modal>
						<Modal
							onClose={this.changeConfirmModalStatus}
							isOpen={this.state.isConfirmModalOpen}>
							<ConfirmModal
								changeModalStatus={this.changeConfirmModalStatus}
								tripOptionOnSelect={this.tripOptionOnSelect}
							/>
						</Modal>
					</React.Fragment>
				) : (
					<NoTripsFound message={msg} />
				)}
			</StyledContainer>
		)
	}
}

async function tripOptionOnSelect() {
	let params = {
		...this.state.options,
		tripIndex: this.state.options.index
	}

	if (params.doUpgrade) {
		params = {
			...params,
			...params.arr[params.upgradeTo.index],
			tripIndex: params.upgradeTo.index
		}

		this.props.setIsUpgrade(false)
	}

	// ehConexao nao existe mais na API - uma oferta e conexao quando tem mais
	// de uma perna (offer.legs.length > 1); cada perna usa leg.legBusToken e
	// kind = 'connectionLeg' (nao a direcao) na chamada de seat-map.
	const selectedPriceId = params.price && (params.price.id || params.price.selectedPriceId)
	const trecho = legsFromOffer(params, 'outbound', selectedPriceId)
	const ehConexao = trecho.length > 1

	return this.onOptionSelected({
		...params,
		ehConexao,
		conexao: ehConexao
			? {
					grupoId: params.busToken,
					quantidadeTrechos: trecho.length,
					trecho
			  }
			: null,
		totalSeats: params.availability ? params.availability.count : 0,
		origemId: params.origin && params.origin.id,
		destinoId: params.destination && params.destination.id
	})
}

async function onContinue() {
	const {
		conexaoStore,
		ordemViagemIdaConexao,
		loadBusSeatsGoingConexao
	} = this.props

	if (
		conexaoStore.ehConexaoIda &&
		conexaoStore.ordemViagemIda < conexaoStore.quantidadeViagensIda
	) {
		//chamar bus set
		ordemViagemIdaConexao()

		try {
			await loadBusSeatsGoingConexao(
				conexaoStore.conexaoIda.trecho[conexaoStore.ordemViagemIda]
			)
		} catch (error) {
			this.props.toastWarning({
				message:
					error.message ||
					'Erro ao buscar poltronas do próximo ônibus, tente novamente.'
			})
			this.props.setStepOrderCurrent(this.props.stepOrderCurrent - 1)
			return
		}

		this.openModal()
	} else {
		const { tripDateReturn, hasReturnTrip } = this.props

		this.closeModal()

		if (tripDateReturn && !hasReturnTrip) {
			this.setState({
				isNoReturnModalOpen: true
			})
		} else {
			this.checkoutToNextStep()
		}
	}
}

function checkoutToNextStep() {
	const { user } = this.props
	const hasPublicBody = user && user.hasPublicBody

	this.props.setPaymentMethod(hasPublicBody ? 'muvicard' : 'creditCard')
	this.props.setDiscountPercent(0)
	this.props.setDiscountLabel('')
	this.props.setDiscountValue(0)
	this.props.resetDiscountCoupon()

	const { hasReturnTrip, selectedBusSeatsGoing } = this.props

	const isGoingSelected = !hasReturnTrip && !!selectedBusSeatsGoing.length

	if (isGoingSelected) {
		this.props.setEtapaPagamento(true)
	}

	this.closeModal()
	this.props.hideLoading()
	this.props.nextStep()
}

async function onOptionSelected({
	group,
	price,
	service,
	tripIndex,
	totalSeats,
	ehConexao,
	conexao,
	origemId,
	destinoId
}) {
	const {
		setTotalSeatsGoing,
		setSelectedTripGoing,
		setSelectedPriceGoing,
		setGroupAndServiceGoing,
		viagemIdaConexao,
		ordemViagemIdaConexao,
		loadBusSeatsGoingConexao,
		resetBusSeatSelection,
		showLoading,
		hideLoading
	} = this.props

	setSelectedPriceGoing(price)
	setTotalSeatsGoing(totalSeats)
	setSelectedTripGoing(tripIndex)
	setGroupAndServiceGoing(group, service)
	resetBusSeatSelection()

	showLoading()

	await this.deselectCurrentSeats()

	try {
		if (ehConexao) {
			viagemIdaConexao(conexao)
			ordemViagemIdaConexao()
			await loadBusSeatsGoingConexao(conexao.trecho[0])
		} else {
			const { loadBusSeatsGoing, busSearchParametersGoing } = this.props
			await loadBusSeatsGoing(busSearchParametersGoing)
		}

		this.openModal()
	} catch (error) {
		this.props.toastWarning({
			message:
				error.message ||
				'Erro ao buscar as poltronas do ônibus, tente novamente.'
		})
	} finally {
		hideLoading()
	}
}

function deselectCurrentSeats() {
	const promises = []

	for (const poltronaIda of this.props.selectedPoltonasIda) {
		var params = {
			...poltronaIda,
			busSeat: poltronaIda.number
		}

		const promise = TicketSaleService.cancelBusSeatBooking(params).then(
			({ success }) => {
				if (success) {
					this.props.deselectBusSeatGoing({
						busSeat: poltronaIda.number
					})
				}
			}
		)

		promises.push(promise)
	}

	for (const busSeatReturn of this.props.selectedBusSeatsReturn) {
		var params = {
			...busSeatReturn,
			busSeat: busSeatReturn.number
		}

		const promise = TicketSaleService.cancelBusSeatBooking(params).then(
			({ success }) => {
				if (success) {
					this.props.deselectBusSeatReturn({
						busSeat: busSeatReturn.number
					})
				}
			}
		)

		promises.push(promise)
	}

	return Promise.all(promises)
}

function openModal() {
	this.setState({ isModalOpen: true })
}

function redirectToPlans() {
	history.push(`${routes.CLIENTE}/planos`)
}

function resetSeatsBus() {
	this.deselectCurrentSeats()
	this.closeModal()
	this.props.resetCalculatedValues()
}

function setOptions(options = {}) {
	this.setState({ options }, () => {
		const isItLessThanFourHours = isWithinRebookingWindow(options.departure)

		if (isItLessThanFourHours) {
			this.changeConfirmModalStatus()
		} else {
			this.tripOptionOnSelect()
		}
	})
}

function changeConfirmModalStatus() {
	this.setState({
		isConfirmModalOpen: !this.state.isConfirmModalOpen
	})
}

function closeModal() {
	this.setState({ isModalOpen: false })
}

function positionInitialMobilePage() {
	if (this.tripDate.current) {
		let { offsetTop } = this.tripDate.current

		if (window.innerWidth <= 760) {
			if (offsetTop) {
				this.setState({
					windowPosition: offsetTop
				})
				this.mobileScroll()
			}
		}
	}
}

function mobileScroll() {
	window.scrollTo(0, this.tripDate.current.offsetTop)
}

const StyledContainer = styled.div`
	margin-bottom: 60px;
`

const StyledHeader = styled.div`
	display: flex;
	margin-bottom: 10px;
	font-size: x-large;

	.trip-date {
		align-items: center;
		background: ${PRIMARY_LIGHT};
		border-top-left-radius: 5px;
		color: ${WHITE};
		flex-wrap: ${Browser.isInternetExplorer() ? 'wrap' : 'nowrap'};
		margin-right: 5px;
		padding: 10px 2px;
		text-align: center;
		width: 96px;
		scroll-behavior: smooth;

		.day-of-week {
			text-transform: capitalize;
			font-size: 1.5rem;
		}

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			display: initial;
		}
	}

	.trip-origin-destination {
		background: ${PRIMARY_LIGHT};
		border-top-right-radius: 5px;
		color: ${WHITE};
		flex-grow: 1;
		font-size: large;
		padding: 4px 6px;
		vertical-align: middle;
		font-weight: 600;
		height: auto;
		min-height: 45px;
		position: relative;

		h2 {
			position: absolute;
			top: 48%;
			transform: translateY(-48%);
			font-family: 'Source Sans Pro';
			font-weight: 600;
			font-size: 2.4rem;
			display: flex;
			flex-direction: row;
		}

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			font-size: inherit;
		}
	}
`

const mapDispatchToProps = {
	hideLoading: SiteCreators.hideLoading,
	showLoading: SiteCreators.showLoading,
	setIsUpgrade: TicketSaleCreators.setIsUpgradeGoing,
	resetDiscountCoupon: TicketSaleCreators.resetDiscountCoupon,
	resetBusSeatSelection: busSeatSelectionActions.reset,
	loadBusSeatsGoing: busSeatSelectionActions.loadBusSeatsGoing,
	setSelectedTripGoing: TicketSaleCreators.setSelectedTripGoing,
	selectBusSeatGoing: busSeatSelectionActions.selectBusSeatGoing,
	setTotalSeatsGoing: busSeatSelectionActions.setTotalSeatsGoing,
	setSelectedPriceGoing: TicketSaleCreators.setSelectedPriceGoing,
	deselectBusSeatGoing: busSeatSelectionActions.deselectBusSeatGoing,
	setGroupAndServiceGoing: TicketSaleCreators.setGroupAndServiceGoing,
	deselectBusSeatReturn: busSeatSelectionActions.deselectBusSeatReturn,
	setPaymentMethod: TicketSaleCreators.paymentMethod,
	setOrdemViagemIda: busSeatSelectionActions.setOrdemViagemIda,
	loadBusSeatsGoingConexao: busSeatSelectionActions.loadBusSeatsGoingConexao,
	viagemIdaConexao: conexaoActions.setViagemIda,
	ordemViagemIdaConexao: conexaoActions.setOrdemViagemIda,
	getConexao: conexaoActions.getConexaoState,
	setEtapaPagamento: TicketSaleCreators.setEtapaPagamento,
	getEtapaPagamento: ticketSaleActions.getEtapaPagamento,
	toastWarning: toastActions.warning,
	setStepOrderCurrent: TicketSaleCreators.setStepOrderCurrent,
	setOriginGoing: TicketSaleCreators.updateOriginGoing,
	setDestinationGoing: TicketSaleCreators.updateDestinationGoing,
	resetCalculatedValues: TicketSaleCreators.resetCalculatedValues,
	performSearchTrips: TicketSaleCreators.performSearchTrips
}

const mapStateToProps = store => ({
	user: store.user,
	originTitle: store.ticketSale.originTitle,
	originState: store.ticketSale.originState,
	destinationTitle: store.ticketSale.destinationTitle,
	destinationState: store.ticketSale.destinationState,
	setDiscountLabel: TicketSaleCreators.discountLabel,
	setDiscountValue: TicketSaleCreators.discountValue,
	setDiscountPercent: TicketSaleCreators.discountPercent,
	tripDateGoing: store.ticketSale.tripDateGoing,
	busSeatsGoing: store.busSeatSelection.busSeatsGoing,
	totalSeatsGoing: store.busSeatSelection.totalSeatsGoing,
	tripsGoing: TicketSaleSelectors.getTripsGoing(store),
	hasReturnTrip: TicketSaleSelectors.hasReturnTrip(store),
	tripDateReturn: store.ticketSale.tripDateReturn,
	busSearchParametersGoing: TicketSaleSelectors.getBusSearchParametersGoing(
		store
	),
	selectedBusSeatsGoing: BusSeatSelectionSelectors.getSelectedBusSeatsGoing(
		store.busSeatSelection
	),
	selectedBusSeatsReturn: BusSeatSelectionSelectors.getSelectedBusSeatsReturn(
		store.busSeatSelection
	),
	conexaoStore: store.conexao,
	conexaoOrdermViagemIda: ConexaoSelectors.getOrdemViagemIda(store),
	selectedPoltonasIda: BusSeatSelectionSelectors.getSelectedViagemIda(
		store.busSeatSelection
	),
	stepOrderCurrent: store.ticketSale.stepOrderCurrent,
	rebookingData: store.ticketSale.rebookingData,
	tripDateReturn: store.ticketSale.tripDateReturn,
	calculatedValues: TicketSaleSelectors.getCalculatedValues(store),
})

const OriginSelectStep = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(OriginSelectStepComponent)
)

export default OriginSelectStep
